<template>
  <div class="all">
    <div class="archivestitle">
      <div style="float:left">客户企业档案</div>
      <div style="float:right">
        <el-button size="mini"
                   type="primary"
                   @click="save">保存</el-button>
      </div>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="基本信息">
        <EssentialInformation ref="essentialInformation"></EssentialInformation>
      </el-tab-pane>
      <el-tab-pane label="业务信息">
        <BusinessInformation ref="businessInformation"></BusinessInformation>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EssentialInformation from './essential-information'
import BusinessInformation from './business-information'
export default {
  data () {
    return {
      dataForm: {
      }
    }
  },
  methods: {
    handleClick1 (tab) {
    },
    save () {
      // let flag = this.$refs['essentialInformation'].save()
      // let flag2 = this.$refs['businessInformation'].save()
    }
  },
  components: {
    EssentialInformation,
    BusinessInformation
  }
}
</script>
<style scoped>
.archivestitle {
  width: 100%;
  height: 35px;
  line-height: 35px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
</style>
